<!-- 合并扫码机和二维码弹窗 -->
<template>
  <div class="scan-type-container">
    <div class="mian-wrap flex">
      <div class="radio-wrap">
        <el-radio-group
          v-if="mergeScanVisible"
          v-model="scanTypeRadio"
          @change="handleScanTypeRadioChange"
          class="scan-type-radio flex"
        >
          <!-- 只要线上支付的付款方式 -->
          <el-radio
            border
            :label="item.key"
            v-for="item in originData.payType
              .filter((it) => {
                if (it.key === 7 || it.key === 10) {
                  return it;
                }
              })
              .reverse()"
            :key="item.key"
            size="mini"
            :class="{ active: scanTypeRadio === item.key }"
          >
            {{ item.value }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="scan-wrap">
        <!-- 不销毁组件 -->
        <payment-code-dialog
          :originPaymentDialogVisible="paymentCodeVisible"
          v-show="paymentCodeVisible"
          :originData="originData"
          @change="handlePaymentCodeChange"
        ></payment-code-dialog>
        <!-- 销毁组件，避免多次触发接口 -->
        <scan-pay-code-dialog
          :visible.sync="scanPayCodeVisible"
          v-if="scanPayCodeVisible"
          :order-data="scanPayCodeDialogData"
          @close="handlePaymentCodeChange"
        >
        </scan-pay-code-dialog>
      </div>
      <div
        class="close-wrap"
        v-if="mergeScanVisible"
        @click="handleMergeScanTypeClose"
      >
        <img
          class="scan-close"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/scan-close.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import paymentCodeDialog from "./paymentCodeDialog.vue";
import scanPayCodeDialog from "./scanPayCodeDialog.vue";

export default {
  name: "mergeScanTypeDialog",
  components: {
    paymentCodeDialog,
    scanPayCodeDialog,
  },
  props: {
    originData: {
      type: Object,
    },
  },
  data() {
    return {
      scanTypeRadio: 7, // 默认付款方式为 7
      paymentCodeVisible: false,
      scanPayCodeVisible: false,
      scanPayCodeDialogData: {}, // scan流程中需要的订单信息
      mergeScanVisible: true,
    };
  },
  watch: {
    scanTypeRadio: {
      handler(n) {
        // console.log("originData", this.originData);
        if (n === 7) {
          this.paymentCodeVisible = true;
          this.scanPayCodeVisible = false;
        } else if (n === 10) {
          this.paymentCodeVisible = false;
          this.scanPayCodeVisible = true;
        }
      },
      immediate: true,
      deep: false,
    },
  },
  methods: {
    // 更换付款方式
    handleScanTypeRadioChange() {
      let params = {};
      params.payment_methods = [
        {
          payment_method_id: Number(this.scanTypeRadio),
          amount: String(this.originData.amount),
        },
      ]; // 支付方式
      if (this.scanTypeRadio === 10) {
        // 扫客户付款码
        this.scanPayCodeDialogData = {
          student_name: this.originData.student_name,
          student_mobile: this.originData.student_mobile,
          amount: this.originData.amount,
          order_id: this.originData.order_id,
          payment_methods: params.payment_methods,
        };
      }
    },
    // 主动点击关闭，跳转详情页
    handleMergeScanTypeClose() {
      this.paymentCodeVisible = false; // 置为 false，关闭订单轮询
      this.scanPayCodeVisible = false;
      this.mergeScanVisible = false;
      // 异步跳转与关闭
      setTimeout(() => {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            id: String(this.originData.order_id),
          },
        });
        this.$emit("change", false);
      }, 100);
    },
    handlePaymentCodeChange() {
      this.handleMergeScanTypeClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.scan-type-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  .mian-wrap {
    justify-content: center;
    align-items: flex-start;
    margin: 93px auto;
    .radio-wrap {
      /deep/.scan-type-radio {
        width: 150px;
        flex-wrap: wrap;
        .el-radio {
          margin: 0 0 15px 0;
          padding: 10px 15px 0 18px !important;
          width: 150px;
          height: 33px;
          background: white;
          color: rgba(92, 93, 94, 1);
          border-radius: 16px;
          font-size: 12px;
          font-weight: 700;
          .el-radio__label {
            padding-left: 8px;
          }
        }
        .active {
          background: rgba(69, 177, 59, 1);
          border-color: rgba(69, 177, 59, 1);
          .is-checked {
            color: white;
            .el-radio__inner {
              border-color: white;
              background: rgba(69, 177, 59, 1);
            }
          }
          .el-radio__label {
            color: white;
          }
        }
      }
    }
    .scan-wrap {
      margin: 0 50px;
      background: white;
      border-radius: 10px !important;
    }
    .close-wrap {
      .scan-close {
        width: 21px;
        height: 21px;
        cursor: pointer;
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
